import {useMemo} from 'react'

import {getDraftJobs} from '../../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {usePipelineId} from '../../../../../../../hooks/pipeline'

import {validators} from './useJobNameValidationError.consts'

import useValidationErrorMessage from 'src/components/pages/PipelinesPages/hooks/useValidationErrorMessage'
import {useAppSelector} from 'src/hooks/react-redux'

function useJobNameValidationError(name: string, savedName: string) {
  const id = usePipelineId()
  const jobs = useAppSelector(state => getDraftJobs(state, id))
  const jobNames = useMemo(
    () => Object.keys(jobs ?? {}).filter(jobName => jobName !== savedName),
    [savedName, jobs],
  )
  const jobNameSpotErrorId = `parameter_name_${savedName}`
  const {errorMessage: jobNameErrorMessage, handlerValidationError: handlerJobNameValidation} =
    useValidationErrorMessage(
      {
        value: name,
        validators,
        compareArray: jobNames,
      },
      jobNameSpotErrorId,
      savedName,
    )

  return {
    handlerJobNameValidation,
    jobNameErrorMessage,
  }
}

export default useJobNameValidationError
